import { useEffect } from "react";

export default function Signup() {
  useEffect(() => {
    const hash = window.location.hash || "#/signup";
    const query = hash.includes("?") ? hash.split("?")[1] : "";
    const params = new URLSearchParams(query);
    const returnTo = params.get("returnTo");
    let redirectTarget = window.location.origin;

    if (returnTo) {
      const candidate = new URL(returnTo, window.location.origin);
      if (candidate.origin === window.location.origin) {
        redirectTarget = candidate.toString();
      }
    }

    const redirectUrl = `https://yakizakana.net/signup?redirect=${encodeURIComponent(redirectTarget)}`;
    window.location.href = redirectUrl;
  }, []);

  return null;
}
